import { createStore, applyMiddleware, combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
// import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

import reducers from 'reducers';
import config from 'config';

import sagas from 'redux/sagas';
import moduleReducers from 'redux/reducers';

import { sagaCatch } from './sagaCatch';

// const loggerMiddleware = createLogger();

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState) {
  const store = createStore(
    combineReducers({
      ...reducers,
      ...moduleReducers,
      intl: intlReducer,
    }),
    initialState,
    composeWithDevTools(
      applyMiddleware(
        thunkMiddleware.withExtraArgument(config), // lets us dispatch() functions
        sagaMiddleware // saga middleware
        // loggerMiddleware // neat middleware that logs actions
      )
    )
  );

  const rootTask = sagaMiddleware.run(sagas);
  rootTask.done.catch(sagaCatch);

  if (module.hot) {
    module.hot.accept('../reducers', () => store.replaceReducer(require('../reducers')));
  }

  return store;
}
